/**
 * @module router/modules/system
 * @description 시스템 관리 도메인 라우트 모듈 — 코드 관리, 요청/수리 유형 관리,
 * 유저 그룹/유저 관리, 권한별 메뉴 관리, 알림 설정 페이지 경로를 정의합니다.
 */
const routes = [
  {
    path: '/code-management',
    name: '코드 관리',
    component: () => import(/* webpackChunkName: "codeManagement" */ '../../views/system/CodeManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/repair-request-type-management',
    name: '요청 유형 관리',
    component: () => import(/* webpackChunkName: "repairRequestTypeManagement" */ '../../views/system/RepairRequestTypeManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  },
  {
    path: '/broken-type-management',
    name: '수리 유형 관리',
    component: () => import(/* webpackChunkName: "brokenTypeManagement" */ '../../views/system/BrokenTypeManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  },
  {
    path: '/user-group-management',
    name: '유저 그룹 관리',
    component: () => import(/* webpackChunkName: "userGroupManagement" */ '../../views/system/UserGroupManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  // SURINP-191 S7-4 (2026-04-29): /user-group-register 라우트 제거 — popup/UserGroupRegister.vue 가
  // popup/UserGroupRegisterModal.vue 로 통합되어 부모 화면 안에서 모달로 동작합니다.
  {
    path: '/user-management',
    name: '유저 관리',
    component: () => import(/* webpackChunkName: "userManagement" */ '../../views/system/UserManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  // SURINP-191 S7-4 (2026-04-29): /user-register 라우트 제거 — popup/UserRegister.vue 가
  // popup/UserRegisterModal.vue 로 통합되어 부모 화면 안에서 모달로 동작합니다.
  {
    path: '/menu-authority-management',
    name: '권한별 메뉴 관리',
    component: () => import(/* webpackChunkName: "menuAuthorityManagement" */ '../../views/system/MenuAuthorityManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/user-group-notification-setting',
    name: '유저 그룹 알림 설정 관리',
    component: () => import(/* webpackChunkName: "userGroupNotificationSetting" */ '../../views/system/UserGroupNotificationSetting.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/staff-customer-notification-setting',
    name: '수리 직원 및 고객 알림 설정 관리',
    component: () => import(/* webpackChunkName: "staffAndCustomerNotificationSetting" */ '../../views/system/StaffAndCustomerNotificationSetting.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  }
]

export default routes
